import "./style.css";
import layout from "./layout.html";
import Text from "@blocks/Text";
import CustomImage from "@blocks/Image";
import Credits from "@blocks/Credits";

export default class Block4 {
  static selector = ".block-4";

  constructor(block, attrs) {
    this.block = block;

    this.block.innerHTML = layout;

    this.imageNode = this.block.querySelector(".image");
    this.textNode = this.block.querySelector(".text");
    this.creditsNode = this.block.querySelector(".credits");

    this.attributes = attrs;
  }

  setup = async () => {
    return new Promise(async (resolve) => {
      await new CustomImage(this.imageNode, this.attributes.image).onReady();
      await new Text(this.textNode, this.attributes.text).onReady();
      await new Credits(this.creditsNode, this.attributes.credits).onReady();

      resolve();
    });
  };

  onReady = async () => {
    return new Promise(async (resolve) => {
      this.mounted = true;
      await this.setup();
      resolve();
    });
  };
}
